// Campus photo for /colleges/michigan-state-university: CC BY-SA 2.5, by The original uploader was Jeffness at English Wikipedia ., from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMSU_Beaumont_Tower_1.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/michigan-state-university/; credited under the photo.
const photo = {
    "slug": "michigan-state-university",
    "alt": "Beaumont Tower among the trees on the Michigan State University campus in East Lansing, Michigan",
    "src": "/colleges/michigan-state-university/campus-1600.webp",
    "srcSmall": "/colleges/michigan-state-university/campus-800.webp",
    "srcMid": "/colleges/michigan-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/michigan-state-university/og.jpg",
    "title": "MSU Beaumont Tower 1",
    "author": "The original uploader was Jeffness at English Wikipedia .",
    "license": "CC BY-SA 2.5",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.5",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMSU_Beaumont_Tower_1.jpg",
    "read": "2026-10-02"
};

export default photo;
